import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { HelpersService } from './helpers.service';

@Injectable({
  providedIn: 'root',
})
export class SchemaService {
  private renderer: Renderer2;
  helpersService = inject(HelpersService);

  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  addJsonLd(json: any, type: string = 'application/ld+json') {
    const script = this.renderer.createElement('script');
    script.type = type;
    script.text = JSON.stringify(json, null, 2);
    this.renderer.appendChild(this.helpersService.doc.head, script);
  }

  // Requires an array of JSON-LD Metadata
  updateSchemaForUrl(schema: Array<Object>) {
    Object.entries(schema).forEach(([key, value]) => {
      this.addJsonLd(value);
    });
  }

  clearAllSchema() {
    const scripts = this.helpersService.doc.querySelectorAll('script[type="application/ld+json"]');
    scripts.forEach((script: Element) => {
      script.remove();
    });
  }
}
